import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/kreon';
import '@fontsource-variable/source-sans-3';
import '@fontsource/courier-prime/700.css';
import './styles.css';
import './interaction.css';
import { isMsalPopupResponse } from './auth/popup-detect';

// A sign-in popup lands back on this origin with its answer in the
// URL. In MSAL.js v5 the page that receives it must hand it to the window that
// opened it (broadcastResponseToMainFrame) and close; it must not boot the app.
// The answer's own MSAL state says it came from a popup (see popup-detect.ts).
if (isMsalPopupResponse(window.location.href)) {
  void import('@azure/msal-browser/redirect-bridge').then(({ broadcastResponseToMainFrame }) =>
    broadcastResponseToMainFrame().catch(() => window.close()),
  );
} else {
  void import('./app').then(({ App }) => {
    const rootEl = document.getElementById('root');
    if (!rootEl) {
      throw new Error('Root element #root not found');
    }
    createRoot(rootEl).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  });
}
